// What the field service worker may answer (PRD 95 §4.13), as pure functions
// both the worker (src/service-worker.ts) and its tests read.

/** The worker's scope: the technician page and nothing else. */
export const FIELD_SCOPE = '/business/field/';

/**
 * A navigation the worker answers with the cached app shell when the network
 * fails: this origin's field pages only — never another origin (the API is
 * one), never a file.
 */
export function isFieldNavigation(url: URL, origin: string): boolean {
  return url.origin === origin && url.pathname.startsWith(FIELD_SCOPE) && !/\.[a-z0-9]+$/i.test(url.pathname);
}
